// extracted by mini-css-extract-plugin
export default {"primary":"var(--default-primary-color)","primaryRgba":"var(--default-primary-rgba)","hover":"var(--default-hover-color)","secondary":"#ababab","secondaryHover":"#999"};